import { arrayOf, func, number } from 'prop-types';
import React from 'react';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import SingleSelect from '../../generic/SingleSelect';
import {
  associatedBrandShape,
  campaignLineTextBundleShape,
} from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import { COLORS } from '../../utils/constants';
import { tapFlashSuccess } from '../../utils/flash';
import { removeDeprecatedTextBundles } from '../utils/filter-utils';
import PreviewCopyBundle from './PreviewCopyBundle';

class TextBundlesModal extends React.Component {
  state = {
    currentBundle: this.props.textBundles[0],
  };

  updateSelection = event => {
    const { value } = event.target;
    const { textBundles } = this.props;
    this.setState({ currentBundle: textBundles.find(b => b.id === value) });
  };

  render() {
    const {
      toggle,
      onApplyTextBundle,
      onApplyTextBundleToSelectedLines,
      textBundles,
      brand,
      selectedLineIds,
    } = this.props;
    const { currentBundle } = this.state;

    const filteredBundles = removeDeprecatedTextBundles(textBundles);

    const bundleOptionsWithAccount = filteredBundles.map(
      ({ name, id, accountId }) => {
        if (accountId)
          return {
            label: name,
            value: id,
          };
        return null;
      },
    );

    const bundleOptionsWithoutAccount = filteredBundles.map(
      ({ name, id, accountId }) => {
        if (!accountId)
          return {
            label: `${name} (Generic)`,
            value: id,
          };
        return null;
      },
    );

    const bundleOptions = bundleOptionsWithAccount
      .concat(bundleOptionsWithoutAccount)
      .filter(item => item !== null);

    return (
      <>
        <ModalHeader toggle={toggle}>Select a new Copy Type</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup row className="align-items-center">
              <Label for="currentBundle" sm={2}>
                Copy
              </Label>
              <Col sm={10}>
                <SingleSelect
                  options={bundleOptions}
                  onChange={this.updateSelection}
                  value={currentBundle?.id}
                />
              </Col>
            </FormGroup>
          </Form>
          {currentBundle && (
            <div className="mt-4">
              <PreviewCopyBundle bundle={currentBundle} brand={brand} />
              <div className="mt-4">
                <Button
                  onClick={() => {
                    onApplyTextBundle(currentBundle);
                    tapFlashSuccess('Copy applied successfully')();
                  }}
                  color={COLORS.PRIMARY}
                >
                  Apply to all applicable lines
                </Button>
                <Button
                  className="ml-2"
                  disabled={!selectedLineIds.length}
                  onClick={() => {
                    onApplyTextBundleToSelectedLines(currentBundle);
                    tapFlashSuccess(
                      'Copy applied successfully to selected lines',
                    )();
                  }}
                  color={COLORS.PRIMARY}
                >
                  Apply to selected lines only ({selectedLineIds.length})
                </Button>
              </div>
            </div>
          )}
        </ModalBody>
      </>
    );
  }
}

TextBundlesModal.propTypes = {
  toggle: func.isRequired,
  onApplyTextBundle: func.isRequired,
  onApplyTextBundleToSelectedLines: func.isRequired,
  textBundles: arrayOf(campaignLineTextBundleShape.isRequired).isRequired,
  brand: associatedBrandShape.isRequired,
  selectedLineIds: arrayOf(number.isRequired).isRequired,
};

const DefaultTextAssetsWithData = withResolved({
  query: api.getCampaignLineTextBundles,
  deriveQueryArgs: ({ accountId }) => ({
    search: { accountIdOrNone: accountId },
  }),
  as: 'textBundles',
})(TextBundlesModal);

export default createModalToggle(
  'Select Copy Type',
  DefaultTextAssetsWithData,
  { outline: true },
  { size: 'md' },
);
